module.exports = __webpack_public_path__ + "static/media/banner-linkedin-icon.ce5b512c.svg";